export default class ErrorsTypes {
  static get GENERIC_ERROR() { return "GenericError"; }
  static get LOADING_PAGE_ERROR() { return "LoadingPageError"; }
  static get SERVICE_ERROR() { return "ServiceError"; }
  static get SERVICE_JSON_ERROR() { return "ServiceJSONError"; }
  static get SERVICE_UNAUTHORIZED_ERROR() { return "ServiceUnauthorizedError"; }
  static get STRINGS_ERROR() { return "StringsError"; }
  static get STRINGS_JSON_ERROR() { return "StringsJsonError"; }
  static get NOT_IMPLEMENTED_ERROR() { return "NotImplementedError"; }
  static get TEMPLATE_ERROR() { return "TemplateError"; }
  static get LOADING_MODAL_ERROR() { return "LoadingModalError"; }
  static get COOKIE_ERROR() { return "CookieError"; }
  static get STRINGS_BINDING_ERROR() { return "StringsBindingError"; }
  static get MENU_ERROR() { return "MenuError"; }
}
